import { cva, type VariantProps } from 'class-variance-authority';

export const toastContent = cva(['flex w-full items-center justify-between'], {
  variants: {
    variant: {
      normal: '',
      action: '',
      alert: 'items-start',
    },
  },
  defaultVariants: {
    variant: 'normal',
  },
});

export const toastTextWrapper = cva(['flex-3']);

export const toastTitle = cva(
  ['font-semibold w-fit group-data-[front=false]/toast:group-data-[expanded=false]/toast:truncate'],
  {
    variants: {
      hasTitle: {
        true: 'pb-2',
        false: '',
      },
    },
    defaultVariants: {
      hasTitle: false,
    },
  },
);

export const toastSubtitle = cva(
  ['group-data-[front=false]/toast:group-data-[expanded=false]/toast:line-clamp-1'],
  {
    variants: {
      hasTitle: {
        true: 'text-neutral-300',
        false: '',
      },
    },
    defaultVariants: {
      hasTitle: false,
    },
  },
);

export const toastSuffixIcon = cva(['cursor-pointer '], {
  variants: {
    close: {
      true: 'text-neutral-300',
      false: '',
    },
  },
  defaultVariants: { close: false },
});

export type ToastVariants = VariantProps<typeof toastContent>;
